import * as React from 'react';

import { connect } from 'react-redux';

import ListPackagesView from 'list-packages.view';
import { IPackageListingAppState } from '../../redux-state';
import { IPackageListingAppText } from '../../custom/classes/package-listing-text';
import { IPerformanceGroup, IPackage } from '../../custom/classes/production';
import { createSpecialFeatureMap } from '../../helpers/special-feature-helpers';
import { ISpecialFeatureMapValue } from '../../classes/package-listing';
import { AnyAction } from 'redux';
import { setSpecialFeatureMap } from '../../redux-state/actions/package-listing.actions';
import { getAllPackagePerformances } from '../../helpers/performances-selectors';
import { flatMap } from 'lodash';

interface IListPackagesExternalProps {
}

interface DispatchToProps {
    setSpecialFeatureMap: (map: Map<string, ISpecialFeatureMapValue>) => void;
}

interface StateToProps {
    packages: Array<IPackage>;
    text: IPackageListingAppText;
    filterFunction: (option: any) => any;
}

export type ListPackagesProps = IListPackagesExternalProps & StateToProps & DispatchToProps;

export class ListPackagesBase extends React.Component<ListPackagesProps, any> {

    componentDidMount() {
        const allMergedPerformances = flatMap(this.props.packages.map(pkg => getAllPackagePerformances(pkg)));

        const sortedMap = createSpecialFeatureMap(allMergedPerformances, this.props.text.specialFeatureMessages);

        this.props.setSpecialFeatureMap(sortedMap);
    }

    render() {
        return (
            <ListPackagesView {...this.props} />
        )
    }
}

function mapDispatchToProps(dispatch: React.Dispatch<AnyAction>): DispatchToProps {
    return {
        setSpecialFeatureMap: (map) => dispatch(setSpecialFeatureMap(map)),
    }
}

function mapStateToProps(state: IPackageListingAppState, ownProps: IListPackagesExternalProps): StateToProps {
    return {
        packages: state.packageListing.packages,
        text: state.packageListingText,
        filterFunction: state.packageListing.filterFunction,
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(ListPackagesBase);